(function () {
  var ROOT_SELECTOR = '[data-about-us-stats]';
  var VALUE_SELECTOR = '[data-stat-count]';
  var DURATION = 1600;

  function parseStatValue(text) {
    var raw = (text || '').trim();
    var match = raw.match(/^([^\d]*)([\d,]+(?:\.\d+)?)([\s\S]*)$/);

    if (!match) return null;

    return {
      prefix: match[1],
      target: parseFloat(match[2].replace(/,/g, ''), 10),
      suffix: match[3],
      useCommas: match[2].indexOf(',') !== -1
    };
  }

  function formatNumber(value, useCommas) {
    var rounded = Math.round(value);

    if (useCommas) {
      return rounded.toLocaleString('en-US');
    }

    return String(rounded);
  }

  function renderValue(parsed, current) {
    return parsed.prefix + formatNumber(current, parsed.useCommas) + parsed.suffix;
  }

  function animateValue(element, parsed) {
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;

      var progress = Math.min((timestamp - startTime) / DURATION, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = parsed.target * eased;

      element.textContent = renderValue(parsed, current);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.textContent = renderValue(parsed, parsed.target);
      }
    }

    window.requestAnimationFrame(step);
  }

  function initStatValues(root) {
    root.querySelectorAll(VALUE_SELECTOR).forEach(function (element) {
      if (element.dataset.statReady === 'true') return;

      element.dataset.statReady = 'true';

      var parsed = parseStatValue(element.getAttribute('data-stat-count'));

      if (!parsed) return;

      element.textContent = renderValue(parsed, 0);
    });
  }

  function runCountUp(root) {
    if (root.dataset.statsAnimated === 'true') return;

    root.dataset.statsAnimated = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll(VALUE_SELECTOR).forEach(function (element) {
      var parsed = parseStatValue(element.getAttribute('data-stat-count'));

      if (!parsed) return;

      if (reducedMotion) {
        element.textContent = renderValue(parsed, parsed.target);
        return;
      }

      animateValue(element, parsed);
    });
  }

  function initStatsSection(root) {
    if (root.__aboutUsStatsReady) return;

    root.__aboutUsStatsReady = true;
    initStatValues(root);

    if (!('IntersectionObserver' in window)) {
      runCountUp(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          runCountUp(root);
          observer.disconnect();
        });
      },
      {
        threshold: 0.25,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    observer.observe(root);
  }

  function initAllStats() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initStatsSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStats);
  } else {
    initAllStats();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);

    if (root) {
      root.__aboutUsStatsReady = false;
      root.dataset.statsAnimated = 'false';
      root.querySelectorAll(VALUE_SELECTOR).forEach(function (element) {
        element.dataset.statReady = 'false';
      });
      initStatsSection(root);
    }
  });
})();
